import tw from 'tailwind-styled-components'

export const MyProfileWrapper = tw.div`flex flex-col gap-4`
